import { render, staticRenderFns } from "./CookieLaw.vue?vue&type=template&id=fee2fc30"
import script from "./CookieLaw.vue?vue&type=script&lang=js"
export * from "./CookieLaw.vue?vue&type=script&lang=js"
import style0 from "./CookieLaw.vue?vue&type=style&index=0&id=fee2fc30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports